interface RouteLoadingProps {
  readonly label?: string;
  readonly fullscreen?: boolean;
}

/** Loader com marca: substitui o texto solto enquanto rotas e dados carregam. */
export function RouteLoading({ label = 'Carregando o Echo...', fullscreen = true }: RouteLoadingProps): React.JSX.Element {
  return (
    <main className={`route-loading${fullscreen ? ' fullscreen' : ''}`} role="status" aria-live="polite">
      <div className="route-loading-mark" aria-hidden="true">
        <img src="/favicon.svg" alt="" width="44" height="44" />
        <span className="route-loading-ring" />
      </div>
      <p>{label}</p>
    </main>
  );
}

/** Esqueleto genérico de página para carregamentos dentro do shell. */
export function PageSkeleton(): React.JSX.Element {
  return (
    <div className="page-skeleton" role="status" aria-label="Carregando conteúdo">
      <span className="skeleton skeleton-kicker" />
      <span className="skeleton skeleton-title" />
      <span className="skeleton skeleton-text" />
      <div className="skeleton-grid">
        <span className="skeleton skeleton-card" />
        <span className="skeleton skeleton-card" />
        <span className="skeleton skeleton-card" />
        <span className="skeleton skeleton-card" />
      </div>
      <span className="skeleton skeleton-block" />
    </div>
  );
}
